import * as Actions from "./actions";
import initialState from "../store/initialState";

export const loadingReducer = (
  state = initialState.isLoading,
  action: Actions.ActionType
) => {
  switch (action.type) {
    case Actions.SET_LOADING:
      return action.payload;
    default:
      return state;
  }
};
